import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import fr_landing_page from "./locale/js/fr.js";
import en_landing_page from "./locale/js/en.js";
import es_landing_page from "./locale/js/es.js";
import en_academy from "./locale/acjs/en.js";
import es_academy from "./locale/acjs/es.js";
import fr_academy from "./locale/acjs/fr.js";
import en_community from "./locale/cojs/en.js";
import es_community from "./locale/cojs/es.js";
import fr_community from "./locale/cojs/fr.js";

// import en from "./locale/en.json";
// import es from "./locale/es.json";


export const defaultNS = 'common';
export const resources = {
           'en': {
                'enterprise': en_landing_page,
               'academy': en_academy,
               'community': en_community,
            },
           'es': {
            'enterprise': es_landing_page,
           'academy': es_academy,
           'community': es_community,
            },
            'fr': {
              'enterprise': fr_landing_page,
             'academy': fr_academy,
             'community': fr_community,
           },
        };
i18n.use(initReactI18next)
.init({
    interpolation: {
        escapeValue: false,
    },
    lng: 'en',
    fallbackLng: ["fr", "en", "es"],
    debug: true,
    defaultNS,
    react: {
        useSuspense: true,
    },
    resources,
    ns: ['enterprise', 'academy', 'community'] //respective namespaces
});
// i18n
//   .use(LanguageDetector)
//   .use(initReactI18next)
//   .use(Backend)
//   .init({
    // backend: {
    //   // for all available options read the backend's repository readme file
    //   loadPath: '/locales/{{lng}}/{{ns}}.js'
    // }

    // debug: true,

    // fallbackLng: ["fr", "en", "es"],
    // interpolation: {
    //   escapeValue: false,
    // },
    // resources: {
    //   fr: {
    //     translation: { ...fr, ...fr_landing_page },
    //   },
    //   en: {
    //     translation: { ...en, ...en_landing_page },
    //   },
    //   es: {
    //     translation: { ...es, ...es_landing_page },
    //   },

    //   fr: {
    //     translation: { ...fr, ...fr_academy },
    //   },
    //   en: {
    //     translation: { ...en, ...en_academy },
    //   },
    //   es: {
    //     translation: { ...es, ...es_academy },
    //   },
      
    //   fr: {
    //     translation: { ...fr, ...fr_community },
    //   },
    //   en: {
    //     translation: { ...en, ...en_community },
    //   },
    //   es: {
    //     translation: { ...es, ...es_community },
    //   },
    // },

  // });

export default i18n;